import {CELLS} from '../constants';

import {isCellValid} from './isCellValid';

import type {RangesItemDto, ValueAcc, ValueAccCell} from '../typedef';


const getCell = ({value}: ValueAccCell, isSingleAddress?: boolean): ValueAccCell => {
    return {
        value,
        isValid: isSingleAddress || isCellValid(value),
    };
};


type ValidateRangesParams = {
    acc: ValueAcc,
    isSingleAddress?: boolean,
};
type ValidateRanges = {
    nextValueAcc: ValueAcc,
    range: RangesItemDto,
};

export const validateRanges = ({acc, isSingleAddress}: ValidateRangesParams): ValidateRanges => {

    const SA = getCell(acc.SA);
    const SB = getCell(acc.SB);
    const SC = getCell(acc.SC);
    const SD = getCell(acc.SD);
    const EA = getCell(acc.EA, isSingleAddress);
    const EB = getCell(acc.EB, isSingleAddress);
    const EC = getCell(acc.EC, isSingleAddress);
    const ED = getCell(acc.ED, isSingleAddress);

    const nextValueAcc: ValueAcc = {
        [CELLS.START_A]: SA,
        [CELLS.START_B]: SB,
        [CELLS.START_C]: SC,
        [CELLS.START_D]: SD,
        [CELLS.END_A]: EA,
        [CELLS.END_B]: EB,
        [CELLS.END_C]: EC,
        [CELLS.END_D]: ED,
    };

    const start = `${SA.value}.${SB.value}.${SC.value}.${SD.value}`;
    const end = isSingleAddress ? '' : `${EA.value}.${EB.value}.${EC.value}.${ED.value}`;

    return {nextValueAcc, range: {start, end}};
};
